import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import * as firebase from 'firebase/app'
import {notify} from 'react-notify-toast'
import moment from 'moment'

class Daily extends Component {

  constructor() {
    super()

    this.state = {
      showForm: false,
      note: '',
      notes: [],
      noteKey: null,
      user: null
    }

    this.handleChangeNote     = this.handleChangeNote.bind(this)
    this.addNote              = this.addNote.bind(this)
    this.editEntry            = this.editEntry.bind(this)    
    this.showForm             = this.showForm.bind(this)
    this.backToDaily          = this.backToDaily.bind(this)
  }

  render() {

    if ( this.state.user===null ) {
      return (
        <div className="container waitDiv">
          <div ref="waitAnimDiv" className="waitAnim"> </div>
        </div>
      )
    }

    // if user has no name in database, force to fill
    if ( this.state.user.name===undefined || this.state.user.name.trim()==='' ) {

      return (
        <div>
          <br/>
          Por favor, indica tu nombre en la sección de Configuración
          <br/>
          <Link to="/setup" style={{ fontWeight: 'bold', textDecoration: 'none', color: '#000000' }}>
            <button className='btn btn-lignht btn-sm' onClick={this.cancelEdit}>Ir a Configuración</button>
          </Link>
        </div>
      )
    }

    return (
      <div className="module">
        <div className="container moduleHeaderDiv">
            <div className="row rowDiv"><h2>Diario</h2></div>
        </div>

        <div className="row">

          { !this.state.showForm ?
              <div className="col-md-6 centered">
                <button className='btn btn-lignht btn-sm' onClick={this.showForm}>Nueva entrada</button>
                <div className="dailyDiv">
                  {
                    this.state.notes.map( note => {
                      return (
                        <div className="noteDiv" key={note.key}>
                          <small>{note.date}</small>
                          &nbsp;&nbsp;
                          <i className="material-icons btnIcon" onClick={()=>this.editEntry(note)}>edit</i>
                          <br/>
                          {note.note}
                          <hr/>
                        </div>
                      )
                    })
                  }
                </div>
              </div>
            : null
          }
          { this.state.showForm ?
            <div className="col-md-6 schedulerForm centered">
              Crear Nueva Entrada

              <div className="container">

                  <div className="formDiv">
                    <label className="col-form-label formLabel">Introduce texto</label>

                    <textarea className="form-control dailyTextarea" id="note" ref="note" name="note" rows="20"
                          maxLength="1024"
                          value={this.state.note}
                          onChange={this.handleChangeNote}></textarea>

                  </div>

                  <div className="formDiv">
                      <button className='btn btn-lignht btn-sm floatRight' onClick={this.addNote}>Guardar</button>                      
                      <button className='btn btn-lignht btn-sm floatRight' onClick={this.backToDaily}>Cancelar</button>
                  </div>            

                </div>
              </div>
            : null
          }
        </div>
      </div>
    )
  }

  componentDidMount () {
    // load users
    firebase.database().ref("users").on ( 'value', users => {
      let usersMap = new Map()
      let userObj = null
      users.forEach ( user => {
        let u = user.val()
        u.key = user.key
        usersMap.set( u.email, u )
        if ( u.email===firebase.auth().currentUser.email){
          userObj = u
        }
      })
      this.setState({
        usersMap: usersMap,
        user: userObj
      })

      // load user notes
      const userKey = usersMap.get( firebase.auth().currentUser.email ).key

      firebase.database().ref("dailyNotes").orderByChild("user").equalTo(userKey).on ( 'value', snap => {
        let notes = []

        snap.forEach ( note => {
          let n = note.val()
          n.key = note.key
          notes.push( n )
        })
        
        this.setState({
          notes: notes.reverse()
        })
      })
    })    
  }

  handleChangeNote () {
    this.setState({
      note: this.refs.note.value
    })
  }

  addNote() {

    if ( this.state.note.trim()==='' ){
      notify.show ('Introduce texto', 'error', 1250);
      return false
    }

    let userKey = this.state.usersMap.get( firebase.auth().currentUser.email ).key

    if ( this.state.noteKey===null) {
      firebase.database().ref("dailyNotes").push({
        user: userKey,
        date: new moment().format('DD/MM/YYYY HH:mm'),
        note: this.state.note.trim()
      }).then ( span => {      
        this.setState({
          targetDate: null,
          userKey: null,
          selectedEvent: null,
          note: '',
          showForm: false
        })
        notify.show ('Nueva entrada guardada', 'success', 1250)
      })
      .catch( error => {
        notify.show ('Error guardando entrada: ' + error, 'error', 1250)
      })
    } else {

      firebase.database().ref("dailyNotes").child(this.state.noteKey).child("note").set(this.state.note.trim()).then ( span => {      
        this.setState({
          targetDate: null,
          userKey: null,
          selectedEvent: null,
          note: '',
          showForm: false
        })
        notify.show ('Entrada modificada', 'success', 1250)
      })
      .catch( error => {
        notify.show ('Error modificando entrada: ' + error, 'error', 1250)
      })

    }

  }

  showForm () {
    this.setState({
      showForm: true
    })
  }

  editEntry (note) {
    this.setState({
      note: note.note,
      noteKey: note.key,
      showForm: true
    })
  }

  updateEntry(){

  }

  backToDaily () {
    this.setState({
      showForm: false,
      note: ''
    })
  }

}

export default Daily
